module.exports = __webpack_public_path__ + "img/witchsfortune.033c405b.png";